import {
    STORY_CREATE_SUCCESS,
    STORY_CREATE_FAIL,
    STORY_UPDATE_SUCCESS,
    STORY_UPDATE_FAIL,
    STORY_DELETE_SUCCESS,
    STORY_DELETE_FAIL,
    STORY_GET_SUCCESS,
    STORY_GET_FAIL,
    STORY_GET_SINGLE_SUCCESS,
    STORY_GET_SINGLE_FAIL,
    STORY_TOGGLE_PINNED_SUCCESS,
    STORY_TOGGLE_PINNED_FAIL,
    STORY_TOGGLE_MAIN_SUCCESS,
    STORY_TOGGLE_MAIN_FAIL,
} from "../types/storyTypes";

import axios from "axios";
import { SERVER_URL } from '../../config/keys';

// Create a separate axios instance for story actions with proper FormData handling
const storyAxiosInstance = axios.create({
    baseURL: `${SERVER_URL}`,
    withCredentials: true,
});

// Interceptor to dynamically set `Content-Type`
storyAxiosInstance.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
        // For FormData, don't set Content-Type - let the browser/axios handle it with proper boundary
        delete config.headers['Content-Type'];
    } else {
        config.headers['Content-Type'] = 'application/json';
    }
    config.headers['Access-Control-Allow-Origin'] = '*';
    return config;
});

export const storyAuth = () => {
    axios.interceptors.request.use(
        (config) => {
            config.headers = {
                ...config.headers,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            };

            config.withCredentials = true

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
};

export const GetStories = () => {
    storyAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/storytelling/get-stories`, {});
            dispatch({
                type: STORY_GET_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: STORY_GET_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const GetStory = (storyId) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/storytelling/get-story`, { _id: storyId });
            dispatch({
                type: STORY_GET_SINGLE_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    story: response.data.story
                }
            })
            return response.data.story;
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: STORY_GET_SINGLE_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const CreateStory = (data) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const formData = new FormData();

            // Append all fields except file first
            Object.keys(data).forEach(key => {
                if (key !== 'file' && data[key] !== null && data[key] !== undefined) {
                    formData.append(key, data[key]);
                }
            });

            // Append file only if it's a valid File object
            if (data.file && data.file instanceof File) {
                formData.append('file', data.file);
            } else if (!data.file) {
                throw new Error('File is required');
            }

            const response = await storyAxiosInstance.post(`/api-v1/storytelling/create`, formData);
            dispatch({
                type: STORY_CREATE_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message || error.message;
            dispatch({
                type: STORY_CREATE_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const UpdateStory = (data) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const formData = new FormData();

            // Append all fields except file first
            Object.keys(data).forEach(key => {
                if (key !== 'file' && data[key] !== null && data[key] !== undefined) {
                    formData.append(key, data[key]);
                }
            });

            // Append file only if it's a valid File object
            if (data.file && data.file instanceof File) {
                formData.append('file', data.file);
            }

            const response = await storyAxiosInstance.put(`/api-v1/storytelling/update-story`, formData);
            dispatch({
                type: STORY_UPDATE_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message || error.message;
            dispatch({
                type: STORY_UPDATE_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const DeleteStory = (storyId) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/storytelling/delete-story`, { _id: storyId });
            dispatch({
                type: STORY_DELETE_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: STORY_DELETE_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const TogglePinned = (storyId) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const response = await axios.put(`${SERVER_URL}/api-v1/storytelling/toggle-pinned`, { _id: storyId });
            dispatch({
                type: STORY_TOGGLE_PINNED_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: STORY_TOGGLE_PINNED_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

export const ToggleMain = (storyId) => {
    storyAuth();
    return async (dispatch) => {
        try {
            const response = await axios.put(`${SERVER_URL}/api-v1/storytelling/toggle-main`, { _id: storyId });
            dispatch({
                type: STORY_TOGGLE_MAIN_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    stories: response.data.stories || []
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: STORY_TOGGLE_MAIN_FAIL,
                payload: {
                    error: data
                }
            })
        }
    }
}

